import { render, staticRenderFns } from "./firstStep.vue?vue&type=template&id=87bdef32&scoped=true&"
import script from "./firstStep.vue?vue&type=script&lang=js&"
export * from "./firstStep.vue?vue&type=script&lang=js&"
import style0 from "./firstStep.vue?vue&type=style&index=0&id=87bdef32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bdef32",
  null
  
)

export default component.exports